import InviteCodeView from 'src/sections/management/invite-code/view/invite-code-view';

export default function InviteCode() {
  return <InviteCodeView />;
}
